// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Shipping20 from './Shipping20';
import Shipping20Filled from './Shipping20Filled';
import Shipping24 from './Shipping24';
import Shipping24Filled from './Shipping24Filled';
import Shipping40 from './Shipping40';
import Shipping40Filled from './Shipping40Filled';
import Shipping48 from './Shipping48';
import Shipping48Filled from './Shipping48Filled';

type ShippingProps = {
    variation: '20' | '20Filled' | '24' | '24Filled' | '40' | '40Filled' | '48' | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Shipping20,
    Shipping20Filled,
    Shipping24,
    Shipping24Filled,
    Shipping40,
    Shipping40Filled,
    Shipping48,
    Shipping48Filled,
};

const Shipping: FC<ShippingProps> = ({ variation, ...props }) => {
    const variationKey = `Shipping${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Shipping" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Shipping;
